import React, { useRef, useState, useEffect } from 'react';
import { Typography, Tooltip } from '@mui/material';

const TempNameEllipsisText = ({ text }) => {
  const textRef = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      setIsOverflowed(element.scrollWidth > element.clientWidth);
    }
  }, [text]);

  const typography = (
    <Typography
      ref={textRef}
      sx={{
        mb: 1,
        fontSize: '14px',
        fontWeight: 500,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {text}
    </Typography>
  );

  return isOverflowed ? (
    <Tooltip title={text} placement="top">
      {typography}
    </Tooltip>
  ) : (
    typography
  );
};

export default TempNameEllipsisText;
